const rangeInput = document.querySelectorAll('input[id^="amount-range"]');
const periodInput = document.querySelectorAll('input[id^="period-range"]');

const changeValue = e => {
    const currId = e.target.getAttribute('id');
    const rangeVal = document.querySelectorAll(
        `#${currId}-value`
    );

    Object.values(rangeVal).forEach(el => {
        el.innerHTML = e.target.value;
    })
}

const bindMultipleEvents = (el, events, callback) => {
    events.split(' ').forEach(ev => {
        el.addEventListener(ev, e => {
            callback(e)
        })
    })
}

if (rangeInput) {
    Object.values(rangeInput).forEach(el => {
        bindMultipleEvents(el, 'pointermove touchmove mousemove change', changeValue)
    });
}

if (periodInput) {
    Object.values(periodInput).forEach(el => {
        bindMultipleEvents(el, 'pointermove touchmove mousemove change', changeValue)
    });
}
